import { AUDIO_FORMATS } from 'shared/constants/messages';

export const resolveAudioRecordFormat = ({
  isAWebWidgetInbox = false,
  isAWhatsAppChannel = false,
  isATelegramChannel = false,
  isAPIInbox = false,
} = {}) => {
  if (
    isAWebWidgetInbox ||
    isAWhatsAppChannel ||
    isATelegramChannel ||
    isAPIInbox
  ) {
    return AUDIO_FORMATS.MP3;
  }

  return AUDIO_FORMATS.WAV;
};
